import React, {useEffect, useState} from "react";

const ShopifyTemplate = () => {
  return (
    <>
    </>
  )
}

export default ShopifyTemplate;